import httpclient from '../base/httpclient';
import DIApi from './_diApi';

class AreaAPI extends DIApi {
  controllerName = 'Areas';

  getAreaByUserId(param) {
    const request = {
      url: this.getAPIUrl() + '/GetAreaByUserId',
      data: param,
    };

    return httpclient.postAsync(request);
  }
}

export default new AreaAPI();
